<template>
  <div>
    <v-container style="margin-top: 16px">
      <span class="subtitle">{{ $t('preguntasFrecuentes') }}</span>

      <v-expansion-panels style="margin-top: 16px">
        <v-expansion-panel v-for="(faq, index) in preguntas" :key="faq.pregunta" style="margin-bottom: 7px">

            <v-expansion-panel-header class="body-1" style="color: black; background: #fad063; font-weight: bold;">{{ $t(faq.pregunta) }}</v-expansion-panel-header>
            <v-expansion-panel-content class="body-2" style="margin-top: 16px; font-weight: 300">
              <p>{{ $t(faq.parrafo1) }}</p>
              <div v-if= "index==8">
                <p>
                  {{ $t(faq.parrafo2) }} <a href="https://www.google.es/maps/dir/P%C3%A0rquing+Barcelona+Port,+Terminal+E,+Moll+Adossat,+08039+Barcelona//@41.3557162,2.1689873,15z/data=!4m9!4m8!1m5!1m1!1s0x12a4a34b3c88a515:0xe8c564aa31e6725d!2m2!1d2.1737058!2d41.3498438!1m0!3e2">{{ $t(faq.link) }}</a>{{ $t(faq.parrafo3) }}
                </p>
              </div>
              <div v-else>
                <p>{{ $t(faq.parrafo2) }}</p>
                <p>{{ $t(faq.parrafo3) }}</p>
              </div>
            </v-expansion-panel-content>

        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaFAQ",

  data: () => ({
    preguntas: [
      {
        pregunta: "pregunta1",
        parrafo1: "pregunta1Parrafo1",
      },
      {
        pregunta: "pregunta2",
        parrafo1: "pregunta2Parrafo1",
      },
      {
        pregunta: "pregunta3",
        parrafo1: "pregunta3Parrafo1",
      },
      {
        pregunta: "pregunta4",
        parrafo1: "pregunta4Parrafo1",
      },
      {
        pregunta: "pregunta5",
        parrafo1: "pregunta5Parrafo1",
      },
      {
        pregunta: "pregunta6",
        parrafo1: "pregunta6Parrafo1",
      },
      {
        pregunta: "pregunta7",
        parrafo1: "pregunta7Parrafo1",
      },





    ] // fin array preguntas
  })  // fin objeto data
};
</script>
